import thunk from "redux-thunk"
import appDataReducer from "./data"
import { ShowWaitingReducer as showWaiting, ShowLoadingReducer as showSpinner } from "./spinner"
import { ShowBtnsReducer as showBtns } from "./centralBankBtn"
import msgDialog     from "./msgDialog"
import loginState, { LoginStat } from "./auth"
import archiveDialog from "./archiveDialog"
import { MsgDialogProps } from "../components/PublicDialogs/MsgDialog"
import { ArchiveDialogProps } from "../components/PublicDialogs/ArchiveDialog"

interface RootReducerModel {
    data: any;
    showSpinner: (show: boolean, action: any) => boolean;
    showBtns: (show: boolean, action: any) => boolean;
    showWaiting: (show: boolean, action: any) => boolean;
    msgDialog: (msgDialog: MsgDialogProps, action: any) => MsgDialogProps ;
    loginState: (loginState: LoginStat, action: any) => LoginStat;
    archiveDialog: (archiveDialog: ArchiveDialogProps, action: any) => ArchiveDialogProps
}

const redux = require("redux")
const { combineReducers, createStore, applyMiddleware } = redux

let red: RootReducerModel = {
    data: appDataReducer,
    showSpinner,
    showBtns,
    showWaiting,
    msgDialog,
    loginState,
    archiveDialog,
}

const rootReducer = combineReducers(red)

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store